import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { MapListModel } from "src/app/models/MapListModel";
import { MapDetailsList } from "src/app/models/MapDetailsList";
import { MapDetailsServerList } from "src/app/models/MapDetailsServerList";
import { MapModel } from "src/app/models/MapModel";
import { Constants } from 'src/app/utils/constants';
import { AppConfigServiceService } from '../../app-config-service.service';
import { HelpersService } from "../../shared/helpers.service";

@Injectable({
  providedIn: "root"
})
export class MonitorService {
  private currentUpdateTimeSubject: BehaviorSubject<string>;
  public currentUpdateTime: Observable<string>;
  private currentFontSizeSubject: BehaviorSubject<string>;
  public currentFontSize: Observable<string>;
  private currentTableRowSubject: BehaviorSubject<MapModel>;
  public currentTableRow: Observable<MapModel>;

  private currentTimerTickSubject: BehaviorSubject<number>;
  public currentTimerTick: Observable<number>;

  private currentMonitorRowPositionSubject: BehaviorSubject<string>;
  public currentMonitorRowPosition: Observable<string>;
  private currentFilterMonitorRowPositionSubject: BehaviorSubject<string>;
  public currentFilterMonitorRowPosition: Observable<string>;

  /*filter monitor - lahko bi bil tudi en localStorage z objektom*/
  private currentFilterTextSubject: BehaviorSubject<string>;
  public currentFilterText: Observable<string>;

  private currentFilterCheckboxSubject: BehaviorSubject<Array<object>>;
  public currentFilterCheckbox: Observable<Array<object>>;

  private currentFilterDropdownSubject: BehaviorSubject<string>;
  public currentFilterDropdown: Observable<string>;

  private currentGlobalMapSubject: BehaviorSubject<Array<MapModel>>;
  public currentGlobalMap: Observable<Array<MapModel>>;

  private currentTableHeightSubject: BehaviorSubject<string>;
  public currentTableHeight: Observable<string>;

  private currentFilterObjectSubject: BehaviorSubject<Array<any>>;
  public currentFilterObject: Observable<Array<any>>;

  private currentSoundSettingsSubject: BehaviorSubject<boolean>;
  public currentSoundSettings: Observable<boolean>;

  public curHostname;

  constructor(private http: HttpClient, private appConfigService: AppConfigServiceService, private helpersService: HelpersService) {
    this.currentUpdateTimeSubject = new BehaviorSubject<string>(
      JSON.parse(localStorage.getItem("updateTimeSetting"))
    );
    this.currentUpdateTime = this.currentUpdateTimeSubject.asObservable();
    this.currentFontSizeSubject = new BehaviorSubject<string>(
      JSON.parse(localStorage.getItem("fontSizeSetting"))
    );
    this.currentFontSize = this.currentFontSizeSubject.asObservable();
    this.currentTableRowSubject = new BehaviorSubject<MapModel>(
      JSON.parse(localStorage.getItem("tableRow"))
    );
    this.currentTableRow = this.currentTableRowSubject.asObservable();

    this.currentTimerTickSubject = new BehaviorSubject<number>(null);
    this.currentTimerTick = this.currentTimerTickSubject.asObservable();

    this.currentSoundSettingsSubject = new BehaviorSubject<boolean>(
      JSON.parse(localStorage.getItem("soundSetting"))
      );
    this.currentSoundSettings = this.currentSoundSettingsSubject.asObservable();

    this.currentMonitorRowPositionSubject = new BehaviorSubject<string>(
      sessionStorage.getItem("monitorRowPosition")
    );
    this.currentMonitorRowPosition = this.currentMonitorRowPositionSubject.asObservable();


    this.currentFilterMonitorRowPositionSubject = new BehaviorSubject<string>(
      localStorage.getItem("filterMonitorRowPosition")
    );
    this.currentFilterMonitorRowPosition = this.currentFilterMonitorRowPositionSubject.asObservable();

    this.currentFilterTextSubject = new BehaviorSubject<string>(
      sessionStorage.getItem("filterText")
    );
    this.currentFilterText = this.currentFilterTextSubject.asObservable();

    this.currentFilterCheckboxSubject = new BehaviorSubject<Array<object>>(
      JSON.parse(localStorage.getItem("filterCheckbox"))
    );
    this.currentFilterCheckbox = this.currentFilterCheckboxSubject.asObservable();

    this.currentFilterDropdownSubject = new BehaviorSubject<string>(
      sessionStorage.getItem("filterDropdown")
    );
    this.currentFilterDropdown = this.currentFilterDropdownSubject.asObservable();

    this.currentGlobalMapSubject = new BehaviorSubject<Array<MapModel>>(
      JSON.parse(sessionStorage.getItem("globalMap"))
    );
    this.currentGlobalMap = this.currentGlobalMapSubject.asObservable();

    this.currentTableHeightSubject = new BehaviorSubject<string>(
      sessionStorage.getItem("tableHeight")
    );
    this.currentTableHeight = this.currentTableHeightSubject.asObservable();

    this.currentFilterObjectSubject = new BehaviorSubject<Array<any>>(
      JSON.parse(localStorage.getItem("filterObj"))
    );
    this.currentFilterObject = this.currentFilterObjectSubject.asObservable();

    this.helpersService.currentHostname.subscribe( data => {
      this.curHostname = data;
    });
  }

  setCurrentGlobalMap(globalMap) {
    sessionStorage.setItem("globalMap", JSON.stringify(globalMap));
    this.currentFilterTextSubject.next(globalMap);
  }

  setCurrentTableHeight(tableHeight) {
    sessionStorage.setItem("tableHeight", tableHeight);
    this.currentTableHeightSubject.next(tableHeight);
  }

  setCurrentSoundSettings(soundSetting) {
    localStorage.setItem("soundSetting", JSON.stringify(soundSetting));
    this.currentSoundSettingsSubject.next(soundSetting);
  }

  setCurrentMonitorRowPosition(rowPosition) {
    sessionStorage.setItem("monitorRowPosition", rowPosition);
    this.currentMonitorRowPositionSubject.next(rowPosition);
  }

  setCurrentFilterMonitorRowPosition(filterMonitorRowPosition) {
    localStorage.setItem("filterMonitorRowPosition", filterMonitorRowPosition);
    this.currentFilterMonitorRowPositionSubject.next(filterMonitorRowPosition);
  }

  setCurrentFilterText(filterText) {
    sessionStorage.setItem("filterText", filterText);
    this.currentFilterTextSubject.next(filterText);
  }

  setCurrentFilterCheckbox(filterCheckbox) {
    localStorage.setItem("filterCheckbox", JSON.stringify(filterCheckbox));
    this.currentFilterCheckboxSubject.next(filterCheckbox);
  }
  setCurrentFilterDropdown(filterDropdown) {
    sessionStorage.setItem("filterDropdown", filterDropdown);
    this.currentFilterDropdownSubject.next(filterDropdown);
  }

  setCurrentFilterObject(object) {
    localStorage.setItem("filterObj", JSON.stringify(object));
    this.currentFilterObjectSubject.next(object);
  }

  public get currentGlobalMapValue(): Array<MapModel> {
    return this.currentGlobalMapSubject.value;
  }

  public get currentUpdateTimeValue(): string {
    return this.currentUpdateTimeSubject.value;
  }

  public get currentTableHeightValue(): string {
    return this.currentTableHeightSubject.value;
  }

  public get currentSoundSettingValue(): boolean {
    return this.currentSoundSettingsSubject.value;
  }

  public get currentFontSizeValue(): string {
    return this.currentFontSizeSubject.value;
  }

  public get currentTableRowValue(): MapModel {
    return this.currentTableRowSubject.value;
  }

  public get currentTimerTickValue(): number {
    return this.currentTimerTickSubject.value;
  }

  public get currentMonitorRowPositionValue(): string {
    return this.currentMonitorRowPositionSubject.value;
  }

  public get currentFilterMonitorRowPositionValue(): string {
    return this.currentFilterMonitorRowPositionSubject.value;
  }

  public get currentFilterTextValue(): string {
    return this.currentFilterTextSubject.value;
  }

  public get currentFilterCheckboxValue(): Array<object> {
    return this.currentFilterCheckboxSubject.value;
  }

  public get currentFilterDropdownValue(): string {
    return this.currentFilterDropdownSubject.value;
  }

  monitorData(username): Observable<MapListModel> {
    let params = new HttpParams();
    params = params.append("allData", "1");
    params = params.append("user", username);
    return this.http.get<MapListModel>(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/maps",
      { params }
    );
  }

  newUpdateTime(newTime: string) {
    localStorage.setItem("updateTimeSetting", JSON.stringify(newTime));
    this.currentUpdateTimeSubject.next(newTime);
  }

  newFontSize(newFont: string) {
    localStorage.setItem("fontSizeSetting", JSON.stringify(newFont));
    this.currentFontSizeSubject.next(newFont);
    console.log("service " + newFont);
  }

  newTableRow(tableRow: MapModel) {
    localStorage.setItem("tableRow", JSON.stringify(tableRow));
    this.currentTableRowSubject.next(tableRow);
    console.log("service newDetailsList: " + tableRow.SERV_NAMESMALL);
  }

  newTimerTick(tick: number) {
    this.currentTimerTickSubject.next(tick);
  }

  monitorGetDetailsServer(
    serv_address,
    serv_port
  ): Observable<MapDetailsServerList> {
    let params = new HttpParams();
    params = params.append("servAddress", serv_address);
    params = params.append("servDbPort", serv_port);
    return this.http.get<MapDetailsServerList>(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/serverMonitorDetails",
      { params }
    );
  }

  monitorGetDetailsOstali(SERV_HOSTNAME, METHOD): Observable<MapDetailsList> {
    let params = new HttpParams();
    params = params.append("hostname", SERV_HOSTNAME);
    params = params.append("type", METHOD);
    return this.http.get<MapDetailsList>(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/monitorGetDetails",
      { params }
    );
  }

  buttonResujem(
    KEY: string,
    MODU_NAMESMALL: string,
    SERV_NAMESMALL: string,
    METHOD: string,
    VALUE: string,
    username: string
  ) {
    let params = new HttpParams();
    params = params.append("key", KEY);
    params = params.append("moduNamesmall", MODU_NAMESMALL);
    params = params.append("servNamesmall", SERV_NAMESMALL);
    params = params.append("method", METHOD);
    params = params.append("value", VALUE);
    params = params.append("workingUser", username);
    return this.http.get<MapDetailsList>(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/start_working",
      { params }
    );
  }

  buttonKonec(KEY: string) {
    let params = new HttpParams();
    params = params.append("key", KEY);
    return this.http.get<MapDetailsList>(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/stop_working",
      { params }
    );
  }

  killServer(username: string, servAddress: string, servDbPort) {
    let params = new HttpParams();
    params = params.append("username", username);
    params = params.append("servAddress", servAddress);
    params = params.append("servDbPort", servDbPort);
    return this.http.get(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/killUser",
      { params: params }
    );
  }

  killMonitor(hostname, agentId) {
    let params = new HttpParams();
    params = params.append("hostname", hostname);
    params = params.append("agentId", agentId);
    return this.http.get(
      this.curHostname + this.appConfigService.apiMonitor + "lumina/monitorKill",
      { params: params }
    );
  }
}
